import setAppPaneUnderlayVisibility from 'owa-app-pane-underlay/lib/actions/setAppPaneUnderlayVisibility';
import addActiveDrawerPane from '../mutators/addActiveDrawerPane';
import getActiveDrawerPane from '../selectors/getActiveDrawerPane';
import getTabIdFromWindow from '../utils/getTabIdFromWindow';
import getUnderlay from '../utils/getUnderlay';

/**
 * Opens the drawer pane for the given target window.
 * @param paneId - The ID of the pane to open.
 * @param targetWindow - The target window where the pane should be opened.
 */
export default function openDrawerPane(paneId: string, targetWindow: Window = window): void {
    const tabId = getTabIdFromWindow(targetWindow);
    const activePane = getActiveDrawerPane(tabId);

    // If the pane is already open, we don't need to do anything.
    if (activePane === paneId) {
        return;
    }

    // Add the new pane to the active panes.
    // This will also set the pane as the active one for the target window.
    addActiveDrawerPane(paneId, tabId);

    // Show the underlay for the drawer pane.
    // The underlay is used to move the content of the app to the side when the pane is open.
    setAppPaneUnderlayVisibility(
        'drawerPane',
        true /* isShown */,
        true /* shrinkable */,
        undefined /* isPlaceholder */,
        getUnderlay(targetWindow) /* underlay */
    );
}
